import { ThemeProvider, CssBaseline } from '@mui/material';
import { BrowserRouter } from 'react-router-dom';
import { useEffect } from 'react';
import theme from './theme';
import AppRouter from './router/routes';
import { RoleProvider } from './store/RoleContext';
import { EvidenceProvider } from './store/EvidenceStore';
import { NodeConfigProvider } from './utils/nodeConfig';
import { DictProvider } from './hooks/useDict';
import { checkAndReset } from './utils/demoReset';

export default function App() {
  // 演示重置：URL 参数 ?reset=true 清空所有 localStorage
  useEffect(() => {
    checkAndReset();
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <RoleProvider>
        <DictProvider>
          <NodeConfigProvider>
            <EvidenceProvider>
              <BrowserRouter>
                <AppRouter />
              </BrowserRouter>
            </EvidenceProvider>
          </NodeConfigProvider>
        </DictProvider>
      </RoleProvider>
    </ThemeProvider>
  );
}
